var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineFilterAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.169 17.58c-.52-.84-.79-1.82-.79-2.83 0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5c0 1.01-.28 1.99-.8 2.84-.97 1.64-2.77 2.66-4.7 2.66-1.92 0-3.73-1.02-4.71-2.67zm.71-2.83c0 .73.2 1.44.58 2.05a3.995 3.995 0 0 0 3.42 1.95c1.42 0 2.7-.72 3.42-1.94.38-.62.58-1.33.58-2.06 0-2.21-1.79-4-4-4s-4 1.79-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.11 15.48c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.55c.41 0 .75.34.75.75s-.34.75-.75.75h-3.55z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.129 16.54V13c0-.41.34-.75.75-.75s.75.34.75.75v3.55c0 .41-.33.74-.75.74-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54 22.39c-.89-.5-1.42-1.4-1.42-2.41v-5.35c0-.5-.33-1.26-.65-1.65l-3.8-3.99c-.63-.65-1.12-1.74-1.12-2.54V4.12c0-1.61 1.22-2.87 2.77-2.87h13.34a2.77 2.77 0 0 1 2.77 2.77v2.22c0 1.05-.62 2.23-1.22 2.85l-1.8 1.59a.77.77 0 0 1-.67.17c-.27-.07-.56-.1-.86-.1-2.21 0-4 1.79-4 4 0 .73.2 1.44.58 2.06.32.53.75.97 1.25 1.28.22.14.36.38.36.64v.34c0 .79-.48 1.9-1.28 2.37l-1.38.89c-.45.28-.97.42-1.48.42-.48 0-.96-.12-1.39-.36zM4.06 4.12v2.33c0 .36.3 1.1.7 1.5L8.61 12c.51.63 1.02 1.7 1.02 2.64v5.35c0 .66.46.99.65 1.1.43.24.94.23 1.33-.01l1.4-.9c.27-.16.54-.67.56-1.03-.55-.41-1.03-.94-1.39-1.54-.52-.85-.8-1.83-.8-2.83a5.51 5.51 0 0 1 6.32-5.44l1.48-1.31c.34-.35.76-1.18.76-1.77V4.04c0-.7-.57-1.27-1.27-1.27H5.33v-.02c-.71 0-1.27.6-1.27 1.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFilterAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-filter-add.0de38a8b35a8669dbe31c392d52558e2.svg";
export { ForwardRef as ReactComponent };